import { cn } from '@/lib/utils';

import Card from '@/components/atoms/card';
import LinkButton from '@/components/atoms/linkButton';

export interface SimpleCardsProps {
  align?: 'left' | 'center' | 'right';
  spacing?: 'small' | 'medium';
  width?: 'small' | 'large' | 'full';
  children: React.ReactNode;
  url?: string;
  classNames?: {
    root?: string;
  };
}

const alignStyles = {
  left: 'items-start text-left',
  center: 'items-center text-center',
  right: 'items-end text-right',
} as const;

const widthStyles = {
  small: 'min-w-[148px] max-w-[148px]',
  large: 'md:min-w-[238px] md:max-w-[238px] w-full',
  full: 'w-full',
} as const;

export function SimpleCards({
  align = 'left',
  width = 'small',
  children,
  url,
  classNames,
}: SimpleCardsProps) {
  const hasUrl = !!url;

  const rootClassName = cn(
    align && alignStyles[align],
    width && widthStyles[width],
    'flex  self-stretch flex-col px-6 py-8',
    hasUrl ? 'h-full ' : 'h-auto',
    classNames?.root
  );

  const ContentWrapper = () => (
    <Card
      hasHoverEffect={hasUrl}
      classNames={{
        root: rootClassName,
      }}
    >
      {children}
    </Card>
  );

  if (!hasUrl) {
    return <ContentWrapper />;
  }

  return (
    <LinkButton
      href={url}
      noStyles
      classNames={{
        root: cn('sm:w-auto h-auto self-stretch'),
      }}
      data-tracker-component='card'
    >
      <ContentWrapper />
    </LinkButton>
  );
}
